import { useEffect, useRef } from 'react';

// React has trouble when making state updates inside of a setInterval callback so a custom hook is necessary 
const useInterval = (callback, delay) => {

  const callbackRefs = useRef();

  useEffect(() => {
    callbackRefs.current = callback;
  }, [callback]);

  useEffect(() => {
    function onInterval() {
      callbackRefs.current();
    }
    if (delay !== null) {
      let intervalId = setInterval(onInterval, delay);
      return () => clearInterval(intervalId);
    }
  }, [delay]);
};

export { useInterval };


// WEBPACK FOOTER //
// ./src/utility/customHooks/useInterval.js